var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"link text-block"},[_c('div',{staticClass:"link-icon"}),_c('h3',{staticClass:"link-text"},[_c('a',{attrs:{"href":_vm.item.url || false,"target":"_blank","rel":"noopener"}},[_vm._v(_vm._s(_vm.item.content))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }